import React, { createContext, useCallback, useContext, useMemo, useState } from 'react';
import TodoFormModal from '../pages/todo-list/TodoFormModal';
import { normalizeDashboardTableNameForCalendar } from '../utils/tableNameNormalize';
import { resolveTodoRecordDueDate, resolveTodoRecordId } from '../pages/todo-list/todoShared';

const AddTodoFromRecordContext = createContext(null);

export function AddTodoFromRecordProvider({ children }) {
  const [open, setOpen] = useState(false);
  const [presetLink, setPresetLink] = useState(null);

  const openAddTodoForRecord = useCallback(({ tableName, recordId, record, dueDate } = {}) => {
    const id = recordId != null && recordId !== '' ? String(recordId) : resolveTodoRecordId(record);
    const table = normalizeDashboardTableNameForCalendar(tableName) || tableName;
    if (!table || !id) return;
    setPresetLink({
      tableName: table,
      recordId: id,
      dueDate: dueDate || resolveTodoRecordDueDate(record)
    });
    setOpen(true);
  }, []);

  const handleClose = useCallback(() => {
    setOpen(false);
    setPresetLink(null);
  }, []);

  const handleSaved = useCallback(() => {
    if (typeof window !== 'undefined') {
      window.dispatchEvent(new CustomEvent('todos-changed'));
    }
  }, []);

  const value = useMemo(() => ({ openAddTodoForRecord }), [openAddTodoForRecord]);

  return (
    <AddTodoFromRecordContext.Provider value={value}>
      {children}
      <TodoFormModal
        open={open}
        onClose={handleClose}
        presetLink={presetLink}
        onSaved={handleSaved}
      />
    </AddTodoFromRecordContext.Provider>
  );
}

export function useAddTodoFromRecord() {
  return useContext(AddTodoFromRecordContext);
}
